import { render, staticRenderFns } from "./projectInfo.vue?vue&type=template&id=1e87fc7d"
import script from "./projectInfo.vue?vue&type=script&lang=js"
export * from "./projectInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports